// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `th,td{
padding: 12px;
text-align: left;
border-bottom: 1px solid #dddd;
}`, "",{"version":3,"sources":["webpack://./src/components/orders/MerchantSummary.css"],"names":[],"mappings":"AAAA;AACA,aAAa;AACb,gBAAgB;AAChB,8BAA8B;AAC9B","sourcesContent":["th,td{\npadding: 12px;\ntext-align: left;\nborder-bottom: 1px solid #dddd;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
